import classNames from 'classnames';
import * as React from 'react';
import { connect } from 'react-redux';

import AppBar from '@material-ui/core/AppBar';
import IconButton from '@material-ui/core/IconButton';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

import { withDefaultStyles } from '../utils/material-ui/hoc';

class ApplicationBar extends React.Component<any, any> {

    public render() {
        const { classes, app } = this.props;
        return (
            <div style={this.props.style}>
                <AppBar position="fixed"
                        className={classNames(classes.appBar, app.drawerOpen && classes.appBarShift)}>
                    <Toolbar>
                        <IconButton onClick={this.props.toggleDrawer}>
                            {app.drawerOpen ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                        </IconButton>
                        <Typography variant="h6" color="inherit" style={{ width: '100%' }} >
                            {this.props.title}
                        </Typography>
                        {this.props.children}
                    </Toolbar>
                </AppBar>
            </div>
        );
    }

}
const mapStateToProps = (state, ownProps) => {
    return { ...state };
}

export default withDefaultStyles(connect(
    mapStateToProps,
)(ApplicationBar));



// WEBPACK FOOTER //
// ./src/components/application-bar.tsx